import "leaflet"; 
import HtmlObjectMapItemCreator from "../HtmlCreator/htmlObjectMapItemCreator";

export default class MapSection {
    isRegionsList = null;
    map = null;
    container = null;
    initPosition = null;
    zoomLevel = 11;
    markers = [];
    latlng = [];

    constructor(settings, isRegionsList = false) {
        this.settings = settings;
        this.isRegionsList = isRegionsList;
        this.objectMapItemCreator = new HtmlObjectMapItemCreator();
        this.setConfig();
        this.initMap();
        this.addMarkers();
        this.refreshView();
    }

    setConfig = () => {
        this.container = document.getElementById('map');
        this.initPosition = this.settings("mapInitPosition");
        this.markers = this.settings("mapMarkers");
        this.latlng = this.settings("mapLatLng");
    }

    initMap = () => {
        this.map = L.map(this.container, {
            dragging: !L.Browser.mobile,
            tap: !L.Browser.mobile,
        });
        L.tileLayer('https://c.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox.streets'
        }).addTo(this.map);
    }

    addMarkers = () => {
        this.markers.forEach(marker => {
            this.addMarker(marker);
        });
    }

    addMarker = (marker) => {
        if (marker.lat !== '0' && marker.long !== '0') {
            const markerIcon = L.divIcon({
                html: `<div class="object-marker" data-marker-id="${marker.id}">${marker.pricePerNight}</div>`
            });
            const lat = parseFloat(marker.lat);
            const long = parseFloat(marker.long);
            
            L.marker([lat, long], {
                icon: markerIcon
            }).addTo(this.map).on('click', () => {
                const objects = this.container.querySelectorAll('.object--popup');
                const switchButton = document.getElementById('switchToData');
                const point = L.CRS.EPSG3857.latLngToPoint(L.latLng([lat, long]), 13);
                point.y += window.innerWidth < 901 ? 50 : 20;
                
                const latLng = L.CRS.EPSG3857.pointToLatLng(point, 13);
                this.map.panTo(latLng);

                objects.forEach(object => object.remove());
                this.container.appendChild(this.objectMapItemCreator.getElement(marker, this.isRegionsList));
                switchButton.style.bottom = "350px";
            }).on('click', () => {
                this.markerClick(marker.id);
            });
        }
    }

    markerClick = (markerId) => {
        document.querySelectorAll('.object.selected').forEach(object => {
            object.classList.remove('selected');
        });
        document.querySelectorAll('.object-marker.active').forEach(marker => {
            marker.classList.remove('active');
            marker.parentElement.style.zIndex = marker.parentElement.dataset.zIndex;
        });

        const objectDiv = document.querySelector(`.object[data-id="${markerId}"]`);
        objectDiv.classList.add('selected');
        objectDiv.parentNode.scrollTop = objectDiv.offsetTop - objectDiv.parentNode.offsetTop;

        const markerDiv = document.querySelector(`.object-marker[data-marker-id="${markerId}"]`);
        markerDiv.classList.add('active');
        markerDiv.parentElement.style.zIndex = "3000";
    }

    refreshView = () => {
        this.map.invalidateSize();

        if (this.latlng.length !== 0) {
            this.map.fitBounds(new L.LatLngBounds(this.latlng));
        } else {
            this.map.setView([this.initPosition.lat, this.initPosition.long], 13);
        }
    }
}